import React, { memo, useState, useEffect, useContext } from 'react';
import clsx from 'clsx';
import styles from './tv-guide.module.scss';

import testIds from '@smart-tv/e2e/shared/variables';
import Image from '@smart-tv/components/image';
import TvGuideDayViewContext from '../utils/tv-guide-day-view-context';

const TvGuideImage = () => {
  const { activeProgram } = useContext(TvGuideDayViewContext);
  const [delayedImageUrl, setDelayedImageUrl] = useState<string>(activeProgram.imageUrl);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!activeProgram.imageUrl) return;

    let imageReady = false;
    let transitionDone = false;
    let cancelled = false;
    let transitionTimer: ReturnType<typeof setTimeout> | undefined;

    function tryFadeIn() {
      if (imageReady && transitionDone && !cancelled) {
        setVisible(true);
      }
    }
    if (!visible) {
      transitionDone = true;
    } else {
      setVisible(false);
    }

    const fadeOutTimer = setTimeout(() => {
      // Wait for fade-out transition to finish (matches CSS transition duration)
      transitionTimer = setTimeout(() => {
        transitionDone = true;
        tryFadeIn();
      }, 300);

      const img = new window.Image();
      img.src = activeProgram.imageUrl;
      img.onload = img.onerror = function () {
        imageReady = true;
        setDelayedImageUrl(activeProgram.imageUrl);
        tryFadeIn();
      };
      //this 300 ms is to implemente hover intent i.e. the user has to hover over the program for 300 ms before we begin to load the image.
    }, 300);

    return () => {
      cancelled = true;
      clearTimeout(fadeOutTimer);
      clearTimeout(transitionTimer);
    };
    // we need visible to not be in the dependency array, otherwise it will cause an infinite loop resulting in no image being displayed.
    // eslint-disable-next-line
  }, [activeProgram.imageUrl, delayedImageUrl]);

  return (
    <Image
      className={clsx(styles['tv-guide__image'], { [styles['tv-guide__image--hidden']]: !visible })}
      src={delayedImageUrl}
      data-testid={testIds.tvGuide.moreInfo.image}
    />
  );
};

export default memo(TvGuideImage);
